import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { OrgPermission } from '../../../../backend/src/organisation/organisation-permission';
import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface SetOrganisationPermissionInput {
  permission: OrgPermission;
  enabled: boolean;
}

export const useSetOrganisationPermission = (orgId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const setOrganisationPermission = async ({ permission, enabled }: SetOrganisationPermissionInput) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PATCH,
      data: { enabled },
    });

    const response = await fetch(`${APIBaseChronos}/api/org/${orgId}/permissions/${permission}`, fetchConfig);
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || 'Failed to update organisation permission');
    }
  };

  return useMutation({
    mutationFn: setOrganisationPermission,
    onSuccess: () => {
      queryClient.invalidateQueries([QueryEntity.OrganisationById, { orgId }]);
      toast.success('Organisation permissions updated');
    },
    onError: () => {
      toast.error('Something went wrong trying to update that permission. Please try again.');
    },
  });
};
